<template>
  <div class="el-main">
    <el-row class="row">
      <el-col :span="24">
        <el-form class="form" ref="form" :model="form" label-width="90px">
          <el-form-item label="选择日期：" class="form-item">
            <el-date-picker v-model="form.date" type="daterange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="预警类型：" class="form-item">
            <el-select v-model="form.region">
              <el-option label="甲级" value="1"></el-option>
              <el-option label="乙级" value="2"></el-option>
              <el-option label="丙级" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="处理状态：" class="form-item">
            <el-select v-model="form.showdate">
              <el-option label="处理完成" value="hour"></el-option>
              <el-option label="正在处理" value="day"></el-option>
              <el-option label="待处理" value="week"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="form-item">
            <el-button type="primary" size="mini"> 查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="7">
        <div style="height: 270px;margin-top: 20px;padding-right: 20px;">
          <div id="pie2" style="height: 250px;width: 100%;"></div>
        </div>
      </el-col>
      <el-col :span="17">
        <div style="height: 270px;margin-top: 20px;">
          <div id="pie1" style="height: 250px;width: 100%;"></div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <div class="data-title">
        数据列表
      </div>
      <div style="width: 100%;">
		<el-table :data="tableData" border :style="`height:${tableHeight}px;background: none;`">
          <el-table-column type="index" width="50" label="序号"> </el-table-column>
          <el-table-column prop="date" label="报警时间"></el-table-column>
          <el-table-column prop="UserName" label="报警类型"></el-table-column>
          <el-table-column prop="DeviceName" label="设备名称"></el-table-column>
          <el-table-column prop="msg" label="报警信息"></el-table-column>
          <el-table-column prop="code" label="处理意见"></el-table-column>
          <el-table-column prop="address" label="处理状态"></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
			  <el-button @click="handleClick(scope.row)" type="text" size="small">编辑</el-button>
			  <span> | </span>
              <el-button type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-row>
  </div>
</template>
<script>
  import * as echarts from '../../public/static/echart/echarts';
  export default {
    data() {
      return {
        form: {
          region: '1',
          showdate: 'hour',
          date: ''
		},
		tableHeight:"",
        pieChart1: null,
        pieChart2: null,
        tableData: [{
          code: '198',
          msg: "kkk",
          date: '2016-05-02',
          UserName: '王小虎',
          DeviceName: '配电房',
          address: '0'
        }, {
          code: '248',
          msg: "kkk",
          date: '2016-05-04',
          UserName: '王小虎',
          DeviceName: '配电房',
          address: '0'
        }, {
          code: '345',
          msg: "kkk",
          date: '2016-05-01',
          UserName: '王小虎',
          DeviceName: '配电房',
          address: '0'
        }, {
          code: '454',
          msg: "kkk",
          date: '2016-05-03',
          UserName: '王小虎',
          DeviceName: '配电房',
          address: '0'
        }, {
          code: '444',
          msg: "kkk",
          date: '2016-05-03',
          UserName: '王小虎',
          DeviceName: '配电房',
          address: '0'
        }]

      }
    },
    methods: {
      initChart() {
		var _this = this;
        this.pieChart1 = echarts.init(document.getElementById('pie1'));
        this.pieChart2 = echarts.init(document.getElementById('pie2'));
        var option = {
          title: {
            text: '负荷响应情况分析',
            textStyle: {
              color: "#fff"
            }
          },
          grid: {
            left: '5%',
            right: '4%',
            bottom: '10%',
            top: '15%',
          },
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            data: ['基线负荷', '实际负荷'],
            textStyle: {
              color: "#fff"
            }
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: ['0时', '1时', '2时', '3时', '4时', '5时', '6时', '7时', '8时', '9时', '10时', '11时', '12时', '13时',
              '14时', '15时', '16时', '17时', '18时', '19时', '20时', '21时', '22时', '23时'
            ],
            axisLine: {
              lineStyle: {
                color: "#fff",
              }
            }
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              formatter: '{value} kw'
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              }
            }
          },
          series: [{
              name: '基线负荷',
              type: 'line',
              data: [11, 11, 15, 13, 12, 13, 10, 11, 11, 15, 13, 12, 13, 10, 11, 11, 15, 13, 12, 13, 10, 5, 3],
              markPoint: {
                data: [{
                    type: 'max',
                    name: '最大值'
                  },
                  {
                    type: 'min',
                    name: '最小值'
                  }
                ]
              },
            },
            {
              name: '实际负荷',
              type: 'line',
              data: [15, 13, 12, 13, 10, 11, 15, 13, 12, 13, 10, 11, 15, 13, 12, 13, 10, 11, 18, 20, 15, 2, 1, ],
              itemStyle: {
                normal: {
                  color: '#3995ff', //改变折线点的颜色
                  lineStyle: {
                    color: '#3995ff' //改变折线颜色
                  }
                }
              },
            }
          ]
        };
        var option2 = {
          title: {
            text: '预警管理',
            textStyle: {
              color: "#fff"
            }
          },
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b} : {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            left: 'right',
            data: ['非工作时间用电', '电压过高', '电流过高'],
            textStyle: {
              color: "#fff"
            }
          },
          series: [{
            name: '负荷完成度',
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: [{
                value: 64,
                name: '非工作时间用电',
                itemStyle: {
                  normal: {
                    color: '#5dd768', //改变折线点的颜色
                    lineStyle: {
                      color: '#5dd768' //改变折线颜色
                    }
                  }
                },
              },
              {
                value: 20,
                name: '电压过高',
                itemStyle: {
                  normal: {
                    color: '#ff7575', //改变折线点的颜色
                    lineStyle: {
                      color: '#ff7575' //改变折线颜色
                    }
                  }
                },
              }, {
                value: 16,
                name: '电流过高',
                itemStyle: {
                  normal: {
                    color: '#55c9e1', //改变折线点的颜色
                    lineStyle: {
                      color: '#55c9e1' //改变折线颜色
                    }
                  }
                },
              },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              },
            }
          }]
        }
        this.pieChart1.setOption(option, true);
        this.pieChart2.setOption(option2, true);
		window.addEventListener('resize', function(){
			_this.pieChart1.resize();
			_this.pieChart2.resize();
		})
      },
    },
    mounted() {
	  this.initChart();
	  this.tableHeight = document.documentElement.clientHeight - 505;
    }
  }

</script>
<style scoped>
  .el-main {
    padding: 5px;
  }
  .row{
	color: #fff;
	line-height: 38px;
	height: 40px;
  }
</style>